//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "GlobalMetrics",
  props: {
    model: {
      type: Object,
      value: {},
    },
  },

  watch: {
    model() {
      this.fetchGlobalMetrics();
    },
    autoFilled() {
      this.suggestions = this.autoCorrect + this.autoFilled;
    },
    autoCorrect() {
      this.suggestions = this.autoCorrect + this.autoFilled;
    },
  },

  mounted() {
    this.fetchGlobalMetrics();
  },

  data: () => ({
    loading: false,
    suggestions: 0,
    autoFilled: 0,
    autoCorrect: 0,
  }),

  methods: {
    fetchGlobalMetrics() {
      if (!this.model)
        return;
      const name = this.model.properties['ai_model:name'];
      if (name) {
        this.showDialog = false;
        this.$refs.fetchGlobalMetrics.params = {
          modelName: name,
          eventIds: "\"AUTO_FILLED\"",
        }
        this.$refs.fetchGlobalMetrics.get().then((results) => {
          if (results.hits) {
            const value = results.hits.total;
            const incrementSteps = value / 500;
            let time = setInterval(() => {
              if (this.autoFilled >= value) {
                this.autoFilled = value;
                clearInterval(time);
                return;
              }
              this.autoFilled = this.autoFilled + Math.ceil(incrementSteps);
            }, 1);
          }
          this.$refs.fetchGlobalMetrics.params.eventIds = "\"AUTO_CORRECTED\"";
          this.$refs.fetchGlobalMetrics.get().then((results) => {
            const value = results.hits.total;
            const incrementSteps = value / 500;
            this.autoCorrect = 0;
            if (results.hits) {
              let time = setInterval(() => {
                if (this.autoCorrect >= value) {
                  this.autoCorrect = value;
                  clearInterval(time);
                  return;
                }
                this.autoCorrect = this.autoCorrect + Math.ceil(incrementSteps);
              }, 1);
            }
          });
        });
      }
    },
  },
};
